var map = {
	"./Bun.jpg": "77eb",
	"./about-cover.jpg": "f378",
	"./banner-bg(alt_1).jpg": "834c",
	"./banner-bg.jpg": "60e2",
	"./cloudComputing.jpg": "bf6a",
	"./consulting.jpg": "9788",
	"./contacts-cover.jpg": "3536",
	"./dataAnalysis.jpg": "4597",
	"./mobileApplicationDevelopment.jpg": "134b",
	"./old/banner-bg.jpg": "3da3",
	"./services-cover.jpg": "7d53",
	"./sujen.jpg": "68bd",
	"./team_photo.jpg": "4649",
	"./webApplicationDevelopment.jpg": "e807"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "b5a1";